<form class="needs-validation" [class.was-validated]="isValidFormPaymentMethod()">

  <div class="row form-row">
    <div class="col-md-4">
      <div id="nmi_ccnumber"></div>

      @if(!collectJS_ccnumber_validation().valid){
      <div class="custom-invalid-feedback">
        <i class="fas fa-xmark"></i>
        {{collectJS_ccnumber_validation().message}}
      </div>
      }
    </div>
    <div class="col-md-4">
      <div class="form-floating">
        <input type="text" class="form-control" name="ccFirstName" placeholder="Type your first name"
          [ngModel]="paymentMethod().firstName"
          [class.is-invalid]="!paymentMethodValidations.get('firstName')?.()?.valid && paymentMethodValidations.get('firstName')?.()?.touched"
          [class.is-valid]="paymentMethodValidations.get('firstName')?.()?.valid && paymentMethodValidations.get('firstName')?.()?.touched"
          (blur)="validatePaymentMethodField('firstName', $event)"
          (ngModelChange)="updatePaymentMethod({firstName: $event })">
        <label for="ccFirstName">First Name</label>
        <div
          *ngIf="!paymentMethodValidations.get('firstName')?.()?.valid && paymentMethodValidations.get('firstName')?.()?.touched"
          class="invalid-feedback">
          <i class="fas fa-xmark"></i>
          {{ paymentMethodValidations.get('firstName')?.()?.error }}
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-floating">
        <input type="text" class="form-control" name="ccLastName" placeholder="Type your last name"
          [ngModel]="paymentMethod().lastName"
          [class.is-invalid]="!paymentMethodValidations.get('lastName')?.()?.valid && paymentMethodValidations.get('lastName')?.()?.touched"
          [class.is-valid]="paymentMethodValidations.get('lastName')?.()?.valid && paymentMethodValidations.get('lastName')?.()?.touched"
          (blur)="validatePaymentMethodField('lastName', $event)"
          (ngModelChange)="updatePaymentMethod({lastName: $event })">
        <label for="ccLastName">Last Name</label>
        <div
          *ngIf="!paymentMethodValidations.get('lastName')?.()?.valid && paymentMethodValidations.get('lastName')?.()?.touched"
          class="invalid-feedback">
          <i class="fas fa-xmark"></i>
          {{ paymentMethodValidations.get('lastName')?.()?.error }}
        </div>
      </div>
    </div>
  </div>
  <div class="row form-row">
    <div class="col-md-6">
      <div id="nmi_ccexp"></div>

      @if(!collectJS_ccexp_validation().valid){
      <div class="custom-invalid-feedback">
        <i class="fas fa-xmark"></i>
        {{collectJS_ccexp_validation().message}}
      </div>
      }
    </div>
    <div class="col-md-6">
      <div id="nmi_cvv"></div>

      @if(!collectJS_cvv_validation().valid){
      <div class="custom-invalid-feedback">
        <i class="fas fa-xmark"></i>
        {{collectJS_cvv_validation().message}}
      </div>
      }
    </div>
  </div>

  @if(in_selectedMembership()?.configuration?.requireAddress) {
  <div class="mb-3">
    <mat-slide-toggle [(ngModel)]="isCheckedBillingAddress" (change)="billingAddressToggleChangeHandler($event.checked)"
      name="isCheckedBillingAddress"> My delivery address is different than my billing
      address
    </mat-slide-toggle>
  </div>
  } @else {
  <div class="mb-3">
    <p class="signup__sub-head-text">Billing Address Information</p>
  </div>
  }
  @if (isBillingAddressRequired()) {
  <div class="row form-row animated fadeInDown">
    <div class="col-md-6">
      <div class="form-floating ">
        <input type="text" class="form-control" id="addressCtrl2" name="addressCtrl2" placeholder="Type your Address"
          [ngModel]="paymentMethod().address"
          [class.is-invalid]="!paymentMethodValidations.get('address')?.()?.valid && paymentMethodValidations.get('address')?.()?.touched"
          [class.is-valid]="paymentMethodValidations.get('address')?.()?.valid && paymentMethodValidations.get('address')?.()?.touched"
          (blur)="validatePaymentMethodField('address', $event)"
          (ngModelChange)="updatePaymentMethod({address: $event })">
        <label for="addressCtrl2">Address</label>
        <div
          *ngIf="!paymentMethodValidations.get('address')?.()?.valid && paymentMethodValidations.get('address')?.()?.touched"
          class="invalid-feedback">
          <i class="fas fa-xmark"></i>
          {{ paymentMethodValidations.get('address')?.()?.error }}
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control" id="additionalAddressCtrl2" name="additionalAddressCtrl2"
          placeholder="Type your Additional address informatios" [ngModel]="paymentMethod().additionalAddress"
          (ngModelChange)="updatePaymentMethod({additionalAddress: $event })">
        <label for="additionalAddressCtrl2">Additional address information</label>
      </div>
    </div>
  </div>
  <div class="row form-row animated fadeInDown">
    <div class="col-md-4">
      <div class="form-floating">
        <input type="text" class="form-control" id="cityCtrl2" name="cityCtrl2" placeholder="Type your City"
          [ngModel]="paymentMethod().city"
          [class.is-invalid]="!paymentMethodValidations.get('city')?.()?.valid && paymentMethodValidations.get('city')?.()?.touched"
          [class.is-valid]="paymentMethodValidations.get('city')?.()?.valid && paymentMethodValidations.get('city')?.()?.touched"
          (blur)="validatePaymentMethodField('city', $event)" (ngModelChange)="updatePaymentMethod({city: $event })">
        <label for="cityCtrl2">City</label>
        <div
          *ngIf="!paymentMethodValidations.get('city')?.()?.valid && paymentMethodValidations.get('city')?.()?.touched"
          class="invalid-feedback">
          <i class="fas fa-xmark"></i>
          {{ paymentMethodValidations.get('city')?.()?.error }}
        </div>
      </div>
    </div>
    <div class="col">
      <mat-form-field class="w-100">
        <mat-label>State</mat-label>
        <mat-select name="stateCtrl2"
          [class.is-invalid]="!paymentMethodValidations.get('state')?.()?.valid && paymentMethodValidations.get('state')?.()?.touched"
          [class.is-valid]="paymentMethodValidations.get('state')?.()?.valid && paymentMethodValidations.get('state')?.()?.touched"
          (selectionChange)="updatePaymentMethod({state: $event.value})">
          @for (item of states(); track $index) {
          <mat-option [value]="item.id">{{ item.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div
        *ngIf="!paymentMethodValidations.get('state')?.()?.valid && paymentMethodValidations.get('state')?.()?.touched"
        class="invalid-feedback">
        <i class="fas fa-xmark"></i>
        {{ paymentMethodValidations.get('state')?.()?.error }}
      </div>
    </div>
    <div class="col">
      <div class="form-floating">
        <input type="text" class="form-control" id="zipCodeCtrl2" name="zipCodeCtrl2" placeholder="Type your ZIP Code"
          appOnlyNumber [maxlength]="5" [ngModel]="paymentMethod().zipCode"
          [class.is-invalid]="!paymentMethodValidations.get('zipCode')?.()?.valid && paymentMethodValidations.get('zipCode')?.()?.touched"
          [class.is-valid]="paymentMethodValidations.get('zipCode')?.()?.valid && paymentMethodValidations.get('zipCode')?.()?.touched"
          (blur)="validatePaymentMethodField('zipCode', $event)"
          (ngModelChange)="updatePaymentMethod({zipCode: $event })">
        <label for="zipCodeCtrl2">ZIP Code</label>
        <div
          *ngIf="!paymentMethodValidations.get('zipCode')?.()?.valid && paymentMethodValidations.get('zipCode')?.()?.touched"
          class="invalid-feedback">
          <i class="fas fa-xmark"></i>
          {{ paymentMethodValidations.get('zipCode')?.()?.error }}
        </div>
      </div>
    </div>
  </div>
  }

  <app-empty-message [message]="disclaimer" [width100]="true"></app-empty-message>

  <div class="form-row-action">
    <div class="d-grid gap-2 mt-4 col-md-2 col-12 mx-auto">
      <!-- While a membership is waiting to be confirmed the save has to go through
           the modal first, so this button stands in for the one CollectJS tokenizes
           from — which stays in the DOM, hidden, and is clicked once the customer
           has chosen (DEV-11022). -->
      @if (pendingMembershipCharge()) {
      <button type="button" class="btn btn-secondary" (click)="confirmMembershipBeforeSaving()"
        [disabled]="isWaitingResponse() || isDisabledSaveChanges()">
        Continue
      </button>
      }
      <button type="button" class="btn btn-secondary" id="nmiPayButton" #nmiPayButtonRef
        [class.d-none]="pendingMembershipCharge()" (click)="saveChangesHandler()"
        [disabled]="isWaitingResponse() || isDisabledSaveChanges()">
        Continue
      </button>
      <button type="button" class="opacity-0" #btnNMIChangesTrigger></button>
    </div>
  </div>
</form>
